import { render, staticRenderFns } from "./accountsManagement.vue?vue&type=template&id=f6637a22&"
import script from "./accountsManagement.vue?vue&type=script&lang=js&"
export * from "./accountsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports